import React from 'react'
import "./App.css";
import Navbar from './compontant/Navbar';
import About from './compontant/About/About';
import Portfolio from './compontant/Portfolio/Portfolio';
import Blank from './compontant/Blank';
import Contact from './compontant/Contact/Contact';
import Footer from './compontant/Footer/Footer';

function App(){
    return( 
        <div className='app_contain'>
      <Navbar/>
      <About/>
      <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#2f368e" 
      fill-opacity="1"d="M0,192L48,176C96,160,192,128,288,128C384,128,480,160,576,181.3C672,203,768,213,864,186.7C960,160,1056,96,1152,80C1248,64,1344,96,1392,112L1440,128L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z">
        </path></svg>
        <Portfolio/>
         <Blank/>
         <Contact/>
         <Footer/>
        </div>
    )
}
export default App;